export enum PrinterLocation {
  BORCULO = 'Borculo',
  ENSCHEDE = 'Enschede',
  NOKI = 'Nordkirchen',
  NEEDSEWEG = 'Needseweg',
  GREGG = 'Gregg'
}
